import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TrashIcon } from '@heroicons/react/24/solid'
import { Badge, DownloadButton, EmptyValuePlaceholder, Pagination, Spinner } from '@/components/ui'
import { SingleLineAddress } from '@/components/Address'
import { formatDate, formatPeriod } from '@/utils/formatters'
import { useUrlFilters } from '@/hooks/useUrlFilters'
import { deleteRent, fetchRents, setFilters} from "../../quittances/quittancesSlice"

export default () => {
  const dispatch = useDispatch()
  const bien = useSelector(state => state.quittances.bien)
  const location = useSelector(state => state.quittances.location)

  // Récupérer les quittances depuis le store Redux
  const quittances = useSelector(state => state.quittances.items)
  const loading = useSelector(state => state.quittances.loadingStatus.fetchList)
  const filters = useSelector(state => state.quittances.filters)
  const pagination = useSelector(state => state.quittances.pagination)

  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)
  const [ selectedQuittance, setSelectedQuittance] = useState(null)

  const fetchLocationRents = (filters) => location ? fetchRents({...filters, with_file: true, location_id: location.id}) : () => {}
  
  useEffect(() => {
    if (!location) return
    dispatch(fetchLocationRents(filters))
  }, [location?.id])

  useUrlFilters({
    setFiltersAction: setFilters,
    fetchAction: fetchLocationRents,
    filters,
    allowedParams: ['page', 'limit'],
    updateUrlParams: false
  })

  const handlePageChange = (page) => {
    dispatch(setFilters({page}))
  } 

  const handleDelete = (quittance) => {
    setSelectedQuittance(quittance)
    setShowConfirmDialog(true)
  }

  const confirmDelete = () => {
    dispatch(deleteRent(selectedQuittance))
    setSelectedQuittance(null)
    setShowConfirmDialog(false)
  }

  const cancelDelete = () => {
    setSelectedQuittance(null)
    setShowConfirmDialog(false)
  }

  return (
    <div className="min-h-[350px]">
      <div className="flex flex-col mb-4">
        <h2 className="text-xl font-bold flex flex-row">
          <span className='mr-2'>Quittances pour la location de</span>{bien ? <SingleLineAddress data={bien} /> : ''}
        </h2>
        <p>{location?.date_fin_bail ? 'du' : 'à partir du'} {location?.date_effet_bail ? formatDate(location.date_effet_bail) : <EmptyValuePlaceholder/>} {location?.date_fin_bail ? `au ${formatDate(location.date_fin_bail)}` : ''}</p>
      </div>
      <div className="flex flex-wrap gap-4">
        { loading && <div className="w-full text-center"><Spinner color='gray-600'/></div> }
        { !loading && quittances.length == 0 && <p className="w-full text-center">Aucune quittance</p>}
        { !loading && quittances.map( (quittance, index) => (
          <div data-id={quittance.id} data-model="quittance" key={index} className="flex space-x-2 hover:bg-primary-200 p-2 rounded-sm">
            { quittance.pdf_file && <DownloadButton file={quittance.pdf_file} title={`la quittance de ${formatPeriod(quittance.year, quittance.month)}`}/> }
            <div className="flex flex-col">
              <div className="flex">
                <span>Quittance de {formatPeriod(quittance.year, quittance.month)}</span>
                <button 
                  className="ml-2 btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
                  arial-label="Supprimer la quittance"
                  title="Supprimer la quittance"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    handleDelete(quittance)
                  }
                }>
                  <TrashIcon className="w-4 h-4"/>
                </button>
              </div>
              <div className="flex gap-2">
                { quittance.published && <Badge text="dispo sur extranet" color="success" />}
                { quittance.was_uploaded && <Badge text="quittance téléversée" />}
              </div>
            </div>
          </div> 
        ))}
      </div>
      {pagination.totalPages > 1 && (
        <Pagination 
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />
      )}
      {showConfirmDialog && (
        <dialog open className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">Confirmer la suppression</h3>
            <p className="py-4">Êtes-vous sûr de vouloir supprimer la quittance de {formatPeriod(selectedQuittance.year, selectedQuittance.month)} ?</p>
            <p className="py-4">Ceci ne supprimera que le fichier pour pouvoir rectifier la quittance dans le dashboard "Gestion".</p>
            <div className="modal-action">
              <button onClick={confirmDelete} className="btn btn-secondary">Supprimer</button>
              <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
            </div>
          </div>
        </dialog>
      )}
    </div>
  )
}